<template>
  <IntegrationWorkflowWrapper
    v-model:is-enabled="trayState.customObjectPush"
    title="Push to Custom Object"
    description="Push partner overlap data into a Crossbeam custom object to get a detailed view of partner insights, deep analysis and ecosystem reporting."
    :workflow-name="workflowName"
    :status="workflowStatus"
  >
    <div
      class="opportunity-push-setting"
      v-if="trayState.profileType === 'salesforce'"
    >
      <BittsCheckbox
        :checked="trayState.oppPush"
        :disabled="
          !trayState.customObjectPush ||
          !!workflowStatus?.error?.error_type ||
          higherOrderError !== null
        "
        @input="(val) => (trayState.oppPush = val)"
      >
        <template #label>
          <div class="flex items-center text-neutral-text-strong">
            Push&nbsp;
            <TextWithTooltip
              data-testid="opportunity-push-tooltip"
              text="opportunity data"
              tooltip-text="Includes your own opportunity fields (like stage and owner) on overlaps."
              :mount-to-body="false"
            />
          </div>
        </template>
      </BittsCheckbox>
    </div>
  </IntegrationWorkflowWrapper>
</template>

<script setup lang="ts">
import { BittsCheckbox } from '@crossbeam/bitts';

import { computed, inject, toRef } from 'vue';

import TextWithTooltip from '@/components/performance-dashboard/TextWithTooltip.vue';

import useTrayStatus from '@/composables/useTrayStatus';
import { ProvidedTrayState } from '@/injectionKeys/integration_profiles';
import { usePartnerCloudStore } from '@/stores';
import { WorkflowsWithStatus } from '@/types/integrations';

import IntegrationWorkflowWrapper from './IntegrationWorkflowWrapper.vue';

const { getStatusByWorkflowName } = usePartnerCloudStore();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const trayState = inject(ProvidedTrayState)!;

const { higherOrderError } = useTrayStatus(toRef(trayState.enabledTray));

const workflowName = computed<WorkflowsWithStatus | null>(() => {
  switch (trayState.profileType) {
    case 'salesforce':
      return 'SCH.Overlaps to Salesforce [SFDC Overlaps]';
    case 'hubspot':
      return 'Sch. Entry Point: HubSpot Overlap Push';
    default:
      return null;
  }
});

const workflowStatus = computed(() =>
  getStatusByWorkflowName(workflowName.value),
);
</script>
